import { Hotel, HotelFragmentFragment } from '../generated/types';
import { Hotel as HotelType, WithContext } from 'schema-dts';
import stripHtml from 'string-strip-html';

export default function getHotelJsonLd(
  data: HotelFragmentFragment
): WithContext<HotelType> {
  let priceRange = '';
  let minPrice = null;
  let maxPrice = null;

  if (data.rooms) {
    data.rooms.forEach((room) => {
      if (room.prices) {
        room.prices.forEach((price) => {
          if (minPrice === null || price.price < minPrice) {
            minPrice = price.price;
          }

          if (maxPrice === null || price.price > maxPrice) {
            maxPrice = price.price;
          }
        });
      }
    });

    if (minPrice !== null) {
      priceRange = `${minPrice}€`;
    }

    if (maxPrice !== null) {
      priceRange = ` - ${maxPrice}€`;
    }
  }

  let jsonld: WithContext<HotelType> = {
    '@context': 'https://schema.org',
    '@type': 'Hotel',
    name: data.title,
    priceRange,
    address: {
      '@type': 'PostalAddress',
      streetAddress: data.street,
      addressLocality: '',
      addressRegion: data.region?.name,
      postalCode: data.postcode,
      addressCountry: data.country?.isocode,
    },
    telephone: data.phone,
    url: data.fullUrl,
    description: stripHtml(data.detailsForFrontend?.body || ''),
  };

  if (data.teaserImage) {
    jsonld.image = data.teaserImage.url;
  }

  if (data.maxRating && data.averageRating) {
    jsonld.aggregateRating = {
      '@type': 'AggregateRating',
      ratingValue: data.averageRating.total,
      ratingCount: data.averageRating.ratingCount,
      bestRating: data.maxRating,
    };
  }

  if (data.stars) {
    jsonld.starRating = {
      '@type': 'Rating',
      ratingValue: data.stars,
    };
  }

  return {
    ...jsonld,
  };
}
